<label [ngStyle]="labelStyles()" class="position-{{ position() }}">
  @if (icon()) {
    @if (icon()) {
      <mat-icon
        [svgIcon]="icon() ?? ''"
        class="flex-shrink-0 {{ isIconPrefix() ? 'order-1' : 'order-3' }}"
        [ngStyle]="iconStyles()"
      />
    }
  }
  <span class="element-label-text" [ngStyle]="textStyles()">
    <ng-content />
  </span>
  @if (tooltip()) {
    <mat-icon
      svgIcon="icon_question_16"
      class="form-tooltip"
      [style.color]="tooltipColor()"
      [blazeTooltip]="tooltip()"
      matTooltipPosition="above"
    />
  }
</label>
